import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { TabNavEvent } from '@oa/shared-core';

/**
 * Service to facilitate inter-component communication between LeftTab, LeftTabs, ListingConfigurationComponent, and any components referenced in the ListingConfigurationComponent.
 */
@Directive()
@Injectable({
  providedIn: "root",
})
export class ListingConfigurationService {

  @Output() tabActivated = new EventEmitter<TabNavEvent>();

  constructor() {}
}
